import React from 'react';
import PropTypes from 'prop-types';
import Label from './Label';

import './RadioButton.css';
import { ThemeSetup } from '../../themes/ThemeSetup';

const RadioButton = ({ checked, value, label, onChange }) => {
  const input = (
    <input
      name="RadioButton"
      type="radio"
      onChange={() => onChange(value)}
      value={value}
      style={{
        backgroundImage: checked
          ? ThemeSetup.getBackgroundURL('icon_radio_checked.svg')
          : ThemeSetup.getBackgroundURL('icon_radio_unchecked.svg')
      }}
    />
  );

  if (!label) {
    return input;
  }

  return (
    <div name="RadioButton">
      <Label>
        {input}
        <span>{label}</span>
      </Label>
    </div>
  );
};

RadioButton.propTypes = {
  value: PropTypes.any,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

export default RadioButton;

export const RadioButton2 = ({ name, checked, value, label, onChange }) => {
  const input = (
    <input
      name={name}
      type="radio"
      onChange={() => onChange(value)}
      value={value}
      checked={checked}
      
      style={{
        backgroundImage: checked
          ? ThemeSetup.getBackgroundURL('icon_radio_checked.svg')
          : ThemeSetup.getBackgroundURL('icon_radio_unchecked.svg')
       // backgroundImage: checked ? 'url(images/icon_radio_checked.svg)' : 'url(images/icon_radio_unchecked.svg)'
      }}
    />
  );

  if (!label) {
    return input;
  }

  return (
    <div name="RadioButton"  className={checked ? 'checked' : ''}>
      <Label>
        {input}
        <span>{label}</span>
      </Label>
    </div>
  );
};
